import { authenticatorApi } from "@/infrastructure/api/authenticatorApi";
import type { DashboardData } from "@/types/dashboard";

export async function getDashboard(): Promise<DashboardData> {
  const { data } = await authenticatorApi.get<DashboardData>("/hub/dashboard");
  return data;
}
